import { render } from "./Healths.vue?vue&type=template&id=52fbe68b"
import script from "./Healths.vue?vue&type=script&lang=ts"
export * from "./Healths.vue?vue&type=script&lang=ts"
script.render = render

export default script